import lpApp from '../../app/lp_app';

function siblingsObject(key, obj) {
  if (!('lpSiblings' in window)) {
    window.lpSiblings = {};
  }
  if (!(key in window.lpSiblings)) {
    window.lpSiblings[key] = { edit_mode: false };
  }
  window.lpSiblings[key][obj.uiid] = { ...obj };
}
function getSiblingsFamily(key) {
  if (!('lpSiblings' in window)) return false;
  if (key in window.lpSiblings) return window.lpSiblings[key];
  let bs = null;
  Object.values(window.lpSiblings).forEach((idx) => {
    Object.values(idx).forEach((jdx) => {
      if (jdx.uiid === key) { // TODO: add
        const cId = (typeof jdx.id === 'string') ? jdx.id.split('_')[0] : jdx.id;
        if (lpApp.references.getOption(cId).meta.type === 'radio') bs = idx;
      }
    });
  });
  return bs;
}


function endEditionMode(key, val) {
  if (!('lpSiblings' in window)) return false;
  if (key in window.lpSiblings) return window.lpSiblings[key];
  Object.keys(window.lpSiblings).forEach((idx) => {
    const tmp = window.lpSiblings[idx];
    Object.values(tmp).forEach((jdx) => {
      if (jdx.uiid === key) window.lpSiblings[idx].edit_mode = val;
    });
  });
  return true;
}

export {
  getSiblingsFamily,
  siblingsObject,
  endEditionMode,
};



// WEBPACK FOOTER //
// ./src/components/utils/siblings.js